// How each pay rule reads on the Pay rules screen: a question the HR person recognises and answers in their own words.
// The server sends the key, the allowed values and the current value; the sentences are here.
const RULE_TEXT = {
  "payroll.unpaid_leave_for": {
    label: "Who loses pay for approved leave",
    choices: { none: "No one", juniors: "Juniors only", everyone: "Everyone" },
  },
  "payroll.unpaid_leave_types": {
    label: "Leave types that are always unpaid",
    hint: "Names separated by commas. A day of such leave costs a day of pay for anyone. Used when a date covered by two leave requests counts once.",
  },
  "payroll.lop_basis": {
    label: "Count a month as",
    choices: { calendar: "The actual days in the month", fixed_30: "30 days" },
  },
  "payroll.leave_dates": {
    label: "A date covered by two leave requests",
    choices: { dedupe: "Counts once", legacy_count: "Counts for each request" },
  },
  "payroll.weekend_edges": {
    label: "A weekly off day at the start or end of a leave",
    choices: { trim: "Is not leave", count: "Is leave" },
    hint: "A weekly off day between two leave days is always leave.",
  },
  "payroll.week_off_days": {
    label: "Weekly off days",
    hint: "For example Sun, or Sat,Sun.",
  },
  "payroll.overtime_multiplier": {
    label: "Overtime is paid at",
    choices: { "1": "1 times the hourly rate", "1.25": "1.25 times", "1.5": "1.5 times", "1.75": "1.75 times", "2": "2 times", "2.5": "2.5 times", "3": "3 times" },
    hint: "The Code on Wages sets 2 times as the minimum.",
  },
  "payroll.pt_threshold": { label: "Professional tax starts at monthly pay of (₹)" },
  "payroll.pt_amount": { label: "Professional tax each month (₹)" },
};

// The choices of a rule as options for a select: the server's allowed values, in words.
export function ruleOptions(rule) {
  const words = RULE_TEXT[rule.key]?.choices || {};
  if (rule.kind === "bool") return [true, false].map((value) => ({ value: String(value), label: words[String(value)] || String(value) }));
  return (rule.choices || []).map((value) => ({ value, label: words[value] || value }));
}

export const ruleLabel = (rule) => RULE_TEXT[rule.key]?.label || rule.label;
export const ruleHint = (rule) => RULE_TEXT[rule.key]?.hint || "";

// The value a form field holds, and the value sent back (a bool travels as true/false, a whole number as a number).
export const toField = (rule) => (rule.kind === "bool" ? String(rule.value) : String(rule.value ?? ""));
export function fromField(rule, text) {
  if (rule.kind === "bool") return text === "true";
  if (rule.kind === "int") return Number(text);
  return text;
}
